<template>
  <div>
    <list v-bind="props"/>
  </div>
</template>

<script>
import List from '@/components/admin/List'
import Modal from '@/views/admin/clients/modal'

export default {
  components: {
    List
  },
  data () {
    return {
      props: {
        plural: 'clients',
        singular: 'client',
        fetchUrl: 'clients',
        actionUrl: 'client',
        fields: [
          {
            key: 'id',
            class: 'idColumn'
          },
          {
            key: 'name'
          },
          {
            key: 'email'
          },
          {
            key: 'actions',
            label: 'Actions',
            class: 'actions'
          }
        ],
        modalComponent: Modal
      }
    }
  }
}
</script>
